// src/components/invoices/InvoiceDetailsSkeleton.tsx
import { Box, Flex, HStack, Skeleton, SkeletonText } from '@chakra-ui/react'

export default function InvoiceDetailsSkeleton() {
  return (
    <Box w="full">
      <Flex
        justify="space-between"
        align="center"
        px={{ base: 2, md: 4 }}
        py={4}
        gap={4}
        wrap="wrap"
      >
        <Skeleton height="18px" width="220px" />
        <HStack gap={0} justifyContent="space-between" w="full">
          <Skeleton height="14px" width="50px" />
          <Skeleton height="14px" width="120px" />
          <Skeleton height="14px" width="90px" />
        </HStack>
      </Flex>

      <Flex
        justify="flex-end"
        px={{ base: 2, md: 4 }}
        py={4}
        borderBottomWidth="2px"
        borderBottomColor="border"
        gap={3}
        wrap="wrap"
      >
        <Skeleton height="28px" width="full" />
        <Skeleton height="28px" width="full" />
      </Flex>

      <Box px={{ base: 2, md: 4 }} py={6} maxH="520px" overflowY="auto">
        <SkeletonText noOfLines={2} gap={3} />
        <Box mt={6}>
          <HStack>
            <SkeletonText noOfLines={5} gap={3} />
            <SkeletonText noOfLines={5} gap={3} />
            <SkeletonText noOfLines={5} gap={3} />
          </HStack>
        </Box>
        <Box mt={8}>
          <SkeletonText noOfLines={4} gap={3} />
        </Box>
      </Box>
    </Box>
  )
}
